import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M7.457.99A12 12 0 0 1 23.54 7.991a4.325 4.325 0 0 1-.54 3.912 4.33 4.33 0 0 1-3.508 1.81h-3.205a2.571 2.571 0 0 0-.78 5.025c.943.351 1.603 1.203 1.666 2.204a2.451 2.451 0 0 1-1.731 2.613 11.66 11.66 0 0 1-3.22.444 12 12 0 0 1-6.233-1.75 12.094 12.094 0 0 1-5.73-11.078A12.094 12.094 0 0 1 7.457.989ZM7.714 12a2.572 2.572 0 1 0 0-5.144 2.572 2.572 0 0 0 0 5.144ZM18 6.857a2.571 2.571 0 1 1-5.142 0 2.571 2.571 0 0 1 5.142 0ZM7.714 18a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429Z",
			fill: "#531DAB",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}) }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0h24v24H0z",
				fill: "#fff"
			})
		}) })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%3E%3Cpath%20d%3D%22M7.457.99A12%2012%200%200%201%2023.54%207.991a4.325%204.325%200%200%201-.54%203.912%204.33%204.33%200%200%201-3.508%201.81h-3.205a2.571%202.571%200%200%200-.78%205.025c.943.351%201.603%201.203%201.666%202.204a2.451%202.451%200%200%201-1.731%202.613%2011.66%2011.66%200%200%201-3.22.444%2012%2012%200%200%201-6.233-1.75%2012.094%2012.094%200%200%201-5.73-11.078A12.094%2012.094%200%200%201%207.457.989ZM7.714%2012a2.572%202.572%200%201%200%200-5.144%202.572%202.572%200%200%200%200%205.144ZM18%206.857a2.571%202.571%200%201%201-5.142%200%202.571%202.571%200%200%201%205.142%200ZM7.714%2018a1.714%201.714%200%201%200%200-3.429%201.714%201.714%200%200%200%200%203.429Z%22%20fill%3D%22%23531DAB%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22%23fff%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
